import { languageMap } from ".."

languageMap.j = {
	comments: {
		line: "NB.",
	},
}
